export default __webpack_public_path__ + "Blood-Pressure-Self-Monitoring-white.svg";